// компонент, который показывает ограниченный набор значений 15 УС, которые доступны в указанном офисе
import { useState, useEffect, ComponentProps } from 'react';
import { inject, observer } from 'mobx-react';
import { SelectInput, MultiSelectInput } from '../forms';
import { partnerOfficeActions, PartnerOfficeStore } from '../../../partners/store/offices/partnerOfficeStore';

type Ref15ForOfficeSelectorProps = Omit<ComponentProps<typeof SelectInput | typeof MultiSelectInput>, 'value' | 'defaultValue'> & {
    partnerOfficeStore?: PartnerOfficeStore,
    officeId: string,
    serviceId: number,
    multiSelect?: boolean,
    excludedValues?: Array<number>,
    addId?: number,
    addName?: string,
  };

const Ref15ForOfficeSelector = (props: Ref15ForOfficeSelectorProps) => {
  const {
    partnerOfficeStore,
    officeId,
    multiSelect,
    excludedValues,
    serviceId,
    addName,
    addId,
    name,
    placeholder,
    label,
    disabled,
    isNextField,
    ...rest
  } = props;

  const { refValuesForOffice15, refValuesForOfficeRequest15 } = partnerOfficeStore;

  const toAdd = addId ? [{ id: addId, name: addName, refId: 15 }] : [];
  const filteredValues = [...refValuesForOffice15, ...toAdd].filter((v) => (!(excludedValues ?? []).includes(v.id)));

  const [loading, setLoading] = useState(false);

  const loadData = async () => {
    if (officeId && serviceId) {
      if (
        (((refValuesForOfficeRequest15?.partnerOfficeId ?? '') !== officeId)
        || ((refValuesForOfficeRequest15?.serviceId ?? 0) !== serviceId))
         && (!loading)) {
        setLoading(true);
        await partnerOfficeActions.getRefValuesForOffice(
          {
            partnerOfficeId: officeId,
            serviceId,
            refId: 15,
          }
        ).finally(() => setLoading(false));
      }
    } else {
      partnerOfficeActions.clearOfficesServicesForSelector();
    }
  };

  useEffect(() => {
    loadData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [officeId, serviceId]);

  return (
    multiSelect
      ? (
        <MultiSelectInput
          { ...rest }
          name = { name }
          placeholder = { placeholder }
          label = { label }
          isMulti
          noOptionsMessage={ () => { return 'Нет вариантов'; } }
          data={ filteredValues }
          dataTitle='name'
          dataValue='id'
          loading={ loading }
          disabled = { disabled }
          sort
          isNextField = { isNextField }
        />
      )
      : (
        <SelectInput
          { ...rest }
          name = { name }
          placeholder = { placeholder }
          label = { label }
          disabled = { disabled }
          data={ filteredValues }
          dataTitle='name'
          dataValue='id'
          loading={ loading }
          sort
          isNextField = { isNextField }
        />
      )

  );
};

export default inject('partnerOfficeStore')(observer(Ref15ForOfficeSelector));
